import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  TextField,
  EditButton,
  DateField,
  Resource,
  Show,
  ReferenceField,
  SelectInput,
  Filter,
  ReferenceInput,
Datagrid } from "react-admin";


const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="material.name" alwaysOn />
    <ReferenceInput label="Project" source="projectId" reference="projects" perPage={500} alwaysOn>
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const MaterialCertificateList = (props) => {
  return (
    <List {...props} filters={Filters(props)}>
      <div style={{marginTop: '15px'}}>
        <Datagrid rowClick="show">
          <TextField source="id" />
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          {/* Not sortable: the list endpoint prefixes the sort field with the certificate alias */}
          <TextField source="project.name" label="Project" sortable={false} />
          <TextField label="Material" source="material.name" />
          <ReferenceField label="Certificates" source="certificateId" reference="certificates">
            <TextField source="name" />
          </ReferenceField>
          <TextField label="Account" source="account.name" />
          <TextField source="status" />
          <EditButton />
        </Datagrid>
      </div>
    </List>
  );
};

const ShowMaterialCertificate = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField source="id" />
        <TextField label="Material" source="material.name" />
        <ReferenceField label="Certificates" source="certificateId" reference="certificates">
          <TextField source="name" />
        </ReferenceField>
        <TextField label="Account" source="account.name" />
        <TextField source="status" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
      </SimpleForm>
    </Show>
  );
};

const CreateMaterialCertificate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="id" />
        <ReferenceInput label="Material" source="materialId" reference="material">
          <SelectInput optionText="materialName" required={true} />
        </ReferenceInput>
        <ReferenceInput label="Certificates" source="certificateId" reference="certificates">
          <SelectInput optionText="name" required={true} />
        </ReferenceInput>
        <TextInput source="status" />
      </SimpleForm>
    </Create>
  );
};

const EditMaterialCertificate = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
      <TextInput source="id" />
        <ReferenceInput label="Material" source="materialId" reference="material">
          <SelectInput optionText="materialName" required={true} />
        </ReferenceInput>
        <ReferenceInput label="Certificates" source="certificateId" reference="certificates">
          <SelectInput optionText="name" required={true} />
        </ReferenceInput>
        <TextInput source="status" />
      </SimpleForm>
    </Edit>
  );
};


const materialCertificateResource = () => <Resource
  name="materialCertificate"
  options={{ label: 'Material certificates', menuGroup: 'Materials'}}
  list={MaterialCertificateList}
  create={CreateMaterialCertificate}
  edit={EditMaterialCertificate}
  show={ShowMaterialCertificate} />;

export default materialCertificateResource;
